import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/student/{student_account_id}/student_meal_settings
export const studentMealSettings = async (studentAccountId: number) => {
  const response = await new Request().get(
    '/ajax/student/' + studentAccountId + '/student_meal_settings'
  )
  return Util.Obj.keysToCamel(response.data)
}
